// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"a2ee6f9e","239":"88fffa70"}[chunkId] + ".chunk.js";
};